import React, { useState } from 'react';
import { BottomActionBarV2, DialogV2, AritoIcon, AritoFormV2 } from '@/components/custom/erp';
import { searchSchema } from '../../schemas';
import { QuanHuyen } from '@/types/schemas';
import DistrictForm from './DistrictForm';
import { FormMode } from '@/types/form';

// Define the types here until the schema file is properly imported
interface SearchFormValues {
  ma_quan: string;
  ten_quan: string;
  ten_quan2?: string | null;
  ma_tinh?: string | null;
  trang_thai: number;
}

interface DistrictFormattedData {
  ma_quan: string;
  ten_quan: string;
  ten_quan2: string | null;
  ma_tinh: string | null;
  status: string | number;
}

interface DistrictDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: SearchFormValues;
  onClose: () => void;
  onSubmit?: (data: DistrictFormattedData) => void;
  selectedObj?: QuanHuyen | null;
  updateDistrict?: (uuid: string, data: DistrictFormattedData) => Promise<void>;
  addDistrict?: (data: DistrictFormattedData) => Promise<void>;
  // Additional props for view mode actions
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

function DistrictDialog({
  open,
  mode,
  initialData,
  onClose,
  onSubmit,
  selectedObj,
  updateDistrict,
  addDistrict,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: DistrictDialogProps) {
  const handleSubmit = async (data: SearchFormValues) => {
    try {
      // Convert empty strings to valid values
      const ma_quan = data.ma_quan?.trim() || '';
      const ten_quan = data.ten_quan?.trim() || '';

      // Chỉ gửi các trường có giá trị
      const formattedData: DistrictFormattedData = {
        ma_quan: ma_quan,
        ten_quan: ten_quan,
        ten_quan2: data.ten_quan2 || null,
        ma_tinh: data.ma_tinh || null,
        status: data.trang_thai?.toString() || '1'
      };

      try {
        if (mode === 'edit' && selectedObj && updateDistrict) {
          // Chỉ gửi các trường cần thiết khi cập nhật
          const updateData: Partial<DistrictFormattedData> = {};
          if (formattedData.ma_quan) updateData.ma_quan = formattedData.ma_quan;
          if (formattedData.ten_quan) updateData.ten_quan = formattedData.ten_quan;

          // Chỉ gửi các trường khác nếu có giá trị và khác với giá trị hiện tại
          if (formattedData.ten_quan2 !== selectedObj.ten_quan2) {
            updateData.ten_quan2 = formattedData.ten_quan2;
          }

          if (formattedData.ma_tinh !== selectedObj.ma_tinh) {
            updateData.ma_tinh = formattedData.ma_tinh;
          }

          if (formattedData.status !== selectedObj.status) {
            updateData.status = formattedData.status;
          }

          await updateDistrict(selectedObj.uuid, updateData as DistrictFormattedData);
          onClose();
        } else if (mode === 'add' && addDistrict) {
          await addDistrict(formattedData);
          onClose();
        } else if (onSubmit) {
          onSubmit(formattedData);
          onClose();
        }
      } catch (error) {
        console.error('Error in form submission:', error);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
  const title = mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem';

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={title}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={12} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={searchSchema}
          onSubmit={data => {
            handleSubmit(data);
          }}
          initialData={initialData}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<DistrictForm mode={mode} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default DistrictDialog;
